import { render, staticRenderFns } from "./permissionDenied.vue?vue&type=template&id=0a8d2b3d&scoped=true&"
import script from "./permissionDenied.vue?vue&type=script&lang=js&"
export * from "./permissionDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d2b3d",
  null
  
)

export default component.exports